export const ADDRESS_SELECTION_GUIDE_OPTIONS = [
  "id",
  "parentId",
  "name",
  "type",
  "socr",
  "index",
  "cladrCode",
  "okatoCode",
  "fiasId",
  "fiasValue",
  "active",
];
